<template>
  <el-select v-model="state" filterable v-on:change="doChange">
    <el-option key="AC" label="Acre" value="AC"></el-option>
    <el-option key="AL" label="Alagoas" value="AL"></el-option>
    <el-option key="AP" label="Amapá" value="AP"></el-option>
    <el-option key="AM" label="Amazonas" value="AM"></el-option>
    <el-option key="BA" label="Bahia" value="BA"></el-option>
    <el-option key="CE" label="Ceará" value="CE"></el-option>
    <el-option key="DF" label="Distrito Federal" value="DF"></el-option>
    <el-option key="ES" label="Espírito Santo" value="ES"></el-option>
    <el-option key="GO" label="Goiás" value="GO"></el-option>
    <el-option key="MA" label="Maranhão" value="MA"></el-option>
    <el-option key="MT" label="Mato Grosso" value="MT"></el-option>
    <el-option key="MS" label="Mato Grosso do Sul" value="MS"></el-option>
    <el-option key="MG" label="Minas Gerais" value="MG"></el-option>
    <el-option key="PA" label="Pará" value="PA"></el-option>
    <el-option key="PB" label="Paraíba" value="PB"></el-option>
    <el-option key="PR" label="Paraná" value="PR"></el-option>
    <el-option key="PE" label="Pernambuco" value="PE"></el-option>
    <el-option key="PI" label="Piauí" value="PI"></el-option>
    <el-option key="RJ" label="Rio de Janeiro" value="RJ"></el-option>
    <el-option key="RN" label="Rio Grande do Norte" value="RN"></el-option>
    <el-option key="RS" label="Rio Grande do Sul" value="RS"></el-option>
    <el-option key="RO" label="Rondônia" value="RO"></el-option>
    <el-option key="RR" label="Roraima" value="RR"></el-option>
    <el-option key="SC" label="Santa Catarina" value="SC"></el-option>
    <el-option key="SP" label="São Paulo" value="SP"></el-option>
    <el-option key="SE" label="Sergipe" value="SE"></el-option>
    <el-option key="TO" label="Tocantins" value="TO"></el-option>
  </el-select>
</template>

<script>
export default {
  name: "StateList",
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      state: 'SP',
    }
  },
  methods: {
    doChange(ev) {
      this.$emit('change', ev)
    },
  },
}

</script>